/* VelloraSupply — theme.js. Vanilla, no dependencies, defensive throughout. */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Mobile drawer ---------- */
  (function drawer() {
    var el = $('[data-drawer]'), scrim = $('[data-drawer-scrim]');
    var openBtn = $('[data-drawer-open]'), closeBtn = $('[data-drawer-close]');
    if (!el || !openBtn) return;

    function open() {
      el.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      var first = el.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      el.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);
    $$('a', el).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) close();
      if (e.key !== 'Tab' || !el.classList.contains('is-open')) return;
      var f = $$('a[href], button:not([disabled]), input, select, textarea', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* ---------- 2. Megamenu (keyboard + click; CSS handles hover) ---------- */
  (function megamenu() {
    var items = $$('.nav__primary > li[data-has-menu]');
    if (!items.length) return;
    items.forEach(function (li) {
      var trigger = li.querySelector('a[aria-haspopup]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (window.innerWidth < 1160) return;
        e.preventDefault();
        var isOpen = li.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        items.forEach(function (o) {
          if (o !== li) { o.classList.remove('is-open'); var t = o.querySelector('a[aria-haspopup]'); if (t) t.setAttribute('aria-expanded', 'false'); }
        });
      });
    });
    document.addEventListener('click', function (e) {
      items.forEach(function (li) {
        if (!li.contains(e.target)) {
          li.classList.remove('is-open');
          var t = li.querySelector('a[aria-haspopup]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (li) {
        li.classList.remove('is-open');
        var t = li.querySelector('a[aria-haspopup]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  /* ---------- 3. Accordions (FAQ + filters) ---------- */
  (function accordions() {
    $$('.faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) panel.setAttribute('hidden', '');
        else panel.removeAttribute('hidden');
      });
    });
  })();

  /* ---------- 4. Announcement rotation (mobile only) ---------- */
  (function promo() {
    var track = $('[data-promo-track]');
    if (!track) return;
    var msgs = $$('.promo-bar__msg', track);
    if (msgs.length < 2) return;
    var i = 0, timer = null;
    function tick() {
      if (window.innerWidth > 760) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { if (!timer) timer = setInterval(tick, 4000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    start();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  })();

  /* ---------- 5. Product gallery ---------- */
  (function gallery() {
    var main = $('[data-pdp-image]');
    var thumbs = $$('[data-pdp-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        main.removeAttribute('srcset');
        thumbs.forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  })();

  /* ---------- 6. Variant selection ---------- */
  (function variants() {
    var select = $('[data-variant-select]');
    var chips = $$('[data-variant-option]');
    if (!select) return;
    var data = null;
    var raw = $('[data-variants]');
    if (raw) { try { data = JSON.parse(raw.textContent); } catch (e) { data = null; } }

    function currentOptions() {
      var opts = [];
      chips.forEach(function (c) {
        var idx = parseInt(c.getAttribute('data-index'), 10);
        if (c.classList.contains('is-active')) opts[idx] = c.getAttribute('data-value');
      });
      return opts;
    }
    function sync() {
      if (!data) return;
      var opts = currentOptions();
      for (var i = 0; i < data.length; i++) {
        var v = data[i], match = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) {
          select.value = v.id;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (window.history && window.history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          }
          return;
        }
      }
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = chip.getAttribute('data-index');
        chips.forEach(function (o) { if (o.getAttribute('data-index') === idx) o.classList.remove('is-active'); });
        chip.classList.add('is-active');
        sync();
      });
    });
  })();

  /* ---------- 7. Quantity steppers ---------- */
  (function qty() {
    $$('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.qty-control');
        if (!wrap) return;
        var input = wrap.querySelector('input');
        if (!input) return;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var val = parseInt(input.value || '1', 10);
        if (isNaN(val)) val = min;
        val = btn.getAttribute('data-qty') === '+' ? val + 1 : val - 1;
        if (val < min) val = min;
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  })();

  /* ---------- 8. Sticky add-to-basket ---------- */
  (function sticky() {
    var bar = $('[data-sticky-atc]');
    var box = $('.pdp__buybox');
    if (!bar || !box || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(box);
  })();

  /* ---------- 9. Cart auto-update ---------- */
  (function cart() {
    var inputs = $$('[data-cart-qty]');
    if (!inputs.length) return;
    var t = null;
    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var form = input.closest('form');
          if (form) form.submit();
        }, 400);
      });
    });
  })();

  /* ---------- 10. Sort dropdown ---------- */
  (function sort() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  })();

  /* ---------- 11. Page table of contents ---------- */
  (function toc() {
    var box = $('[data-page-toc]');
    var content = $('.page-content');
    if (!box || !content) return;
    var heads = $$('h2', content);
    if (heads.length < 2) { box.style.display = 'none'; return; }
    heads.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      box.appendChild(a);
    });
    if (!('IntersectionObserver' in window)) return;
    var links = $$('a', box);
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id);
        });
      });
    }, { rootMargin: '-20% 0px -70% 0px' }).observe ?
      heads.forEach(function (h) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '-20% 0px -70% 0px' }).observe(h);
      }) : null;
  })();

  /* ---------- 12. Cookie banner ---------- */
  (function cookies() {
    var banner = $('#cookie-banner');
    if (!banner) return;
    var KEY = 'vellora-cookie-consent';
    var stored = null;
    try { stored = window.localStorage.getItem(KEY); } catch (e) { stored = null; }
    if (stored) return;
    setTimeout(function () { banner.removeAttribute('hidden'); banner.classList.add('is-visible'); }, 800);

    function save(value) {
      try { window.localStorage.setItem(KEY, value); } catch (e) {}
      banner.classList.remove('is-visible');
      banner.setAttribute('hidden', '');
    }
    $$('[data-cookie]', banner).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.getAttribute('data-cookie');
        if (action === 'prefs') { var p = $('#cookie-prefs'); if (p) p.classList.toggle('is-open'); return; }
        if (action === 'all') return save('all');
        if (action === 'essential') return save('essential');
        if (action === 'save') {
          var picked = $$('#cookie-prefs input[name]').filter(function (i) { return i.checked; })
            .map(function (i) { return i.name; }).join(',');
          return save(picked || 'essential');
        }
      });
    });
  })();

  /* ---------- 13. Header shadow ---------- */
  (function header() {
    var el = $('[data-header]');
    if (!el) return;
    var onScroll = function () { el.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- 14. Inline form validation ---------- */
  (function forms() {
    $$('form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var bad = false;
        $$('[required]', form).forEach(function (field) {
          var ok = field.value.trim() !== '';
          if (ok && field.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value);
          field.setAttribute('aria-invalid', ok ? 'false' : 'true');
          if (!ok) bad = true;
        });
        if (bad) {
          e.preventDefault();
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) first.focus();
        }
      });
    });
  })();

  /* ---------- 15. Product recommendations ---------- */
  (function recs() {
    var holder = $('[data-recommendations-url]');
    if (!holder || !window.fetch) return;
    fetch(holder.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('[data-recommendations]');
        if (section) holder.replaceWith(section);
      })
      .catch(function () {});
  })();

  if (reduceMotion) document.documentElement.classList.add('reduce-motion');
})();
